import React from 'react';
import PropTypes from 'prop-types';
import { registerField } from 'core/forms';
import { Checkbox } from 'uikit/inputs';
import styles from '../styles/formFieldBoolean.module.scss';

const FormFieldBoolean = ({
  fieldId,
  schema = { checkedIcon: '', isDisabled: false, labelText: '', testId: '', uncheckedIcon: '' },
  updateField,
  value = false,
}) => {
  let inputFieldId = fieldId;

  if (schema.labelText) {
    inputFieldId = `${fieldId}-input`;
  }

  return (
    <Checkbox
      id={inputFieldId}
      name="checkbox"
      className={styles.element}
      value={value}
      label={schema.labelText}
      isDisabled={schema.isDisabled}
      isIndeterminate={schema.isIndeterminate}
      checkedIcon={schema.checkedIcon}
      uncheckedIcon={schema.uncheckedIcon}
      indeterminateIcon={schema.indeterminateIcon}
      onChange={updateField}
      testId={schema.testId}
    />
  );
};

FormFieldBoolean.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.bool,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    labelText: PropTypes.string,
    isDisabled: PropTypes.bool,
  }),
};

registerField('Boolean', React.memo(FormFieldBoolean));

export default FormFieldBoolean;
